import ApiProxy from 'iceqerp-common/api-proxy';

class MyApiProxy extends ApiProxy {
  constructor() {
    super({ baseURL: '/s/e/0/tm/' });
  }

  requestPublic(path, args, conf) {
    return super.request(`p${path}`, args, { ...conf, extWithAuth: false });
  }

  request(path, args, conf) {
    return super.request(`u${path}`, args, conf);
  }

  requestBlob(path, args, conf) {
    return super.requestBlob(`u${path}`, args, conf);
  }
}

export default new MyApiProxy();